module.exports = __webpack_public_path__ + "img/relation.8756d84f.jpg";